import { api } from '../../../api/client.js';

/** Cabeçalho de autenticação do cliente da loja. */
function customerHeaders(token) {
  return token ? { 'X-Customer-Token': token } : {};
}

/**
 * Regista uma pesquisa do cliente (chamado com debounce). Silencioso por design:
 * nunca deve quebrar a navegação da loja.
 *
 * @param {string} slug
 * @param {string} token
 * @param {string} term
 * @returns {Promise<{ok:boolean, results?:number, in_stock?:number, alert_created?:boolean}>}
 */
export async function registerRadarSearch(slug, token, term) {
  if (!slug || !token || !term || term.trim().length < 2) return { ok: false };
  try {
    return await api(`/store/${encodeURIComponent(slug)}/customer/radar/search`, {
      skipAuth: true,
      headers: { ...customerHeaders(token), 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ term: term.trim() }),
    });
  } catch {
    return { ok: false };
  }
}

/**
 * "Avise-me quando chegar" — cria o interesse manual (produto esgotado ou termo).
 *
 * @param {string} slug
 * @param {string} token
 * @param {{ productId?: number, term?: string }} opts
 */
export async function createRadarAlert(slug, token, { productId, term } = {}) {
  const body = {};
  if (productId) body.product_id = productId;
  if (term) body.term = term;
  return api(`/store/${encodeURIComponent(slug)}/customer/radar/alert`, {
    skipAuth: true,
    headers: { ...customerHeaders(token), 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(body),
  });
}

/**
 * Histórico do próprio cliente (eventos + avisos).
 *
 * @param {string} slug
 * @param {string} token
 * @returns {Promise<{radar_enabled:boolean, events:Array<object>, alerts:Array<object>}>}
 */
export async function fetchRadarHistory(slug, token) {
  return api(`/store/${encodeURIComponent(slug)}/customer/radar/history`, {
    skipAuth: true,
    headers: customerHeaders(token),
  });
}

/**
 * Cancela um aviso pendente do próprio cliente.
 *
 * @param {string} slug
 * @param {string} token
 * @param {number} alertId
 */
export async function cancelRadarAlert(slug, token, alertId) {
  return api(`/store/${encodeURIComponent(slug)}/customer/radar/alert/${alertId}`, {
    skipAuth: true,
    headers: customerHeaders(token),
    method: 'DELETE',
  });
}
